import * as React from 'react';
import { cn } from '@/lib/utils';
import { FiStar } from 'react-icons/fi';

const MetricHeader = React.forwardRef(({ className, ...props }, ref) => (
  <header
    ref={ref}
    className={cn('my-5 flex flex-col border-b border-solid border-[#ECE9F8]', className)}
    {...props}
  />
));
MetricHeader.displayName = 'MetricHeader';

const MetricHeaderLevel = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('flex justify-between', className)}
    {...props}
  />
));
MetricHeaderLevel.displayName = 'MetricHeaderLevel';

const MetricHeaderStar = React.forwardRef(({ isActive = false, className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('flex items-center', className)}
    {...props}
  >
    <FiStar
      size={20}
      fill={isActive ? '#7B63BF' : '#BCC4D6'}
      stroke={isActive ? '#7B63BF' : '#BCC4D6'}
    />
  </div>
));
MetricHeaderStar.displayName = 'MetricHeaderStar';

const MetricHeaderTitle = React.forwardRef(({ isDisabled, className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('flex flex-col items-center justify-center text-lg font-bold', isDisabled && 'text-neutral-light', className)}
    {...props}
  />
));
MetricHeaderTitle.displayName = 'MetricHeaderTitle';

const MetricHeaderPoints = React.forwardRef(({ percentage = 0, toFixed = 0, className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn('mb-3 text-sm font-medium', className)}
    {...props}
  />
));
MetricHeaderPoints.displayName = 'MetricHeaderPoints';

export { MetricHeader, MetricHeaderLevel, MetricHeaderStar, MetricHeaderTitle, MetricHeaderPoints };
